/* Vivid Ads native enquiry forms — progressive enhancement only.
   The form submits and validates natively with this file absent or blocked;
   this adds friendlier inline messages, a busy state, and focus management. */
(function () {
  'use strict';
  if (window.__vvFormsBoot) return;
  window.__vvFormsBoot = 1;

  var MSG = {
    valueMissing: 'This field is required.',
    typeMismatch: 'Enter a valid email address, e.g. name@company.com.au',
    tooShort: 'That looks too short — please check it.',
    patternMismatch: 'Please check the format of this field.',
    fallback: 'Please check this field.'
  };

  function messageFor(input) {
    var v = input.validity;
    if (!v || v.valid) return '';
    if (v.valueMissing) return input.getAttribute('data-msg-required') || MSG.valueMissing;
    if (v.typeMismatch) return input.type === 'email' ? MSG.typeMismatch : MSG.fallback;
    if (v.tooShort) return MSG.tooShort;
    if (v.patternMismatch) return input.getAttribute('data-msg-pattern') || MSG.patternMismatch;
    return MSG.fallback;
  }

  function setState(input) {
    var row = input.closest('.vvf__row');
    if (!row) return true;
    var slot = row.querySelector('.vvf__msg');
    var ok = input.checkValidity();
    if (ok) {
      row.classList.remove('is-invalid');
      input.removeAttribute('aria-invalid');
      if (slot) slot.textContent = '';
    } else {
      row.classList.add('is-invalid');
      input.setAttribute('aria-invalid', 'true');
      if (slot) slot.textContent = messageFor(input);
    }
    return ok;
  }

  function wire(form) {
    if (form.__vvWired) return;
    form.__vvWired = 1;
    form.setAttribute('novalidate', 'novalidate'); // we render the messages ourselves

    var fields = [].slice.call(form.querySelectorAll('input, textarea, select'))
      .filter(function (el) { return el.type !== 'hidden' && !el.closest('.vvf__trap'); });

    fields.forEach(function (el) {
      el.addEventListener('blur', function () { setState(el); });
      el.addEventListener('input', function () {
        // only clear an existing error while typing; never nag mid-entry
        var row = el.closest('.vvf__row');
        if (row && row.classList.contains('is-invalid')) setState(el);
      });
    });

    form.addEventListener('submit', function (e) {
      // honeypot: a real person never sees or fills this
      var trap = form.querySelector('.vvf__trap input');
      if (trap && trap.value) { e.preventDefault(); return; }
      var firstBad = null;
      fields.forEach(function (el) { if (!setState(el) && !firstBad) firstBad = el; });
      if (firstBad) {
        e.preventDefault();
        try { firstBad.focus({ preventScroll: true }); } catch (err) { firstBad.focus(); }
        try { firstBad.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) {}
        return;
      }
      var btn = form.querySelector('.vvf__btn');
      if (btn) {
        btn.setAttribute('aria-busy', 'true');
        btn.dataset.label = btn.textContent;
        btn.textContent = 'Sending…';
        // if the browser restores the page from bfcache, put the label back
        setTimeout(function () {
          if (btn.dataset.label) { btn.textContent = btn.dataset.label; btn.removeAttribute('aria-busy'); }
        }, 12000);
      }
    });
  }

  function boot() {
    [].slice.call(document.querySelectorAll('form.vvf__form')).forEach(wire);
    // move focus to the confirmation so screen readers and keyboard users land on it
    var ok = document.querySelector('.vvf__banner--ok');
    if (ok) {
      try { ok.setAttribute('tabindex', '-1'); ok.focus({ preventScroll: true }); } catch (e) {}
      try { ok.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  setTimeout(boot, 1500);
})();
